var map = {
	"./Contact.svg": 4646,
	"./GWAS.svg": 6785,
	"./Search.svg": 9039,
	"./blast.svg": 9410,
	"./browse.svg": 4303,
	"./download.svg": 4782,
	"./home.svg": 9429,
	"./lncRNA.svg": 1292,
	"./network.svg": 5153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;